export const isPaddleEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_PADDLE_ENABLED === 'true';
